import { OrderTypeEnum } from '@core/enums';
import { applyCouponDiscount } from './coupon-discount.util';

export function calculateCartTotal(
	subtotal: bigint,
	taxes: bigint,
	couponDiscount: bigint,
	tip: bigint,
	deliveryCharge: bigint,
	orderType: OrderTypeEnum | null
): bigint {
	const discountedSubtotal = applyCouponDiscount(subtotal, couponDiscount);
	const delivery = orderType === OrderTypeEnum.Delivery ? deliveryCharge : 0n;

	return discountedSubtotal + taxes + tip + delivery;
}
